"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SENT = exports.SENDING = exports.SEND_FAILED = void 0;
var SEND_FAILED = 'send failed';
exports.SEND_FAILED = SEND_FAILED;
var SENDING = 'sending';
exports.SENDING = SENDING;
var SENT = 'sent';
exports.SENT = SENT;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb25zdGFudHMvQWN0aXZpdHlDbGllbnRTdGF0ZS5qcyJdLCJuYW1lcyI6WyJTRU5EX0ZBSUxFRCIsIlNFTkRJTkciLCJTRU5UIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxJQUFNQSxXQUFXLEdBQUcsYUFBcEI7O0FBQ0EsSUFBTUMsT0FBTyxHQUFHLFNBQWhCOztBQUNBLElBQU1DLElBQUksR0FBRyxNQUFiIiwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgU0VORF9GQUlMRUQgPSAnc2VuZCBmYWlsZWQnO1xuY29uc3QgU0VORElORyA9ICdzZW5kaW5nJztcbmNvbnN0IFNFTlQgPSAnc2VudCc7XG5cbmV4cG9ydCB7IFNFTkRfRkFJTEVELCBTRU5ESU5HLCBTRU5UIH07XG4iXX0=